import { DepositSource } from "@configs/statsig/types";
import { useMemberSettings } from "@hooks/useMemberSettings";
import usePostLoginInfo from "@hooks/usePostLoginInfo";
import { _MemberSettingOnboardDialogLayout } from "@types";
import { MemberSettingPlayerNameCollectionMode } from "kz-ui-sdk";
import { useCallback } from "react";
import { closeDeposit, openDeposit } from "../utils";

/**
 * Control the state of the deposit drawer with post login info check
 */
export const useDepositDrawer = () => {
  const { isFulfilled: isPostLoginInfoFulfilled, triggerForm: triggerPostLoginInfoForm } = usePostLoginInfo();
  const { nameCollectionMode } = useMemberSettings();

  const openDepositDrawer = useCallback(
    (props?: { onClose?: () => void; source?: DepositSource }) => {
      // if missing post login info, open post login info form
      // open deposit drawer after post login info form is completed
      if (!isPostLoginInfoFulfilled && nameCollectionMode === MemberSettingPlayerNameCollectionMode.Registration) {
        triggerPostLoginInfoForm(
          "dialog",
          () => {
            openDeposit({
              onClose: props?.onClose,
              source: props?.source,
            });
          },
          {
            layout: _MemberSettingOnboardDialogLayout.DIALOG_DRAWER,
            redirectHomeOnSuccess: false,
          },
        );
        return;
      }

      openDeposit({
        onClose: props?.onClose,
        source: props?.source,
      });
    },
    [isPostLoginInfoFulfilled, triggerPostLoginInfoForm, nameCollectionMode],
  );

  const closeDepositDrawer = useCallback(() => {
    closeDeposit();
  }, []);

  return {
    openDepositDrawer,
    closeDepositDrawer,
  };
};
